import { LocalizedTranslations } from '../localizedTranslations';

export const fr: LocalizedTranslations = {
  // Navigation
  nav: {
    home: 'Accueil',
    europeanMarkets: 'Marchés Européens',
    aboutUs: 'À Propos',
    products: 'Produits',
    oemSolutions: 'Solutions OEM',
    blog: 'Blog',
    clientHub: 'Espace Client',
    agentLogin: 'Connexion Agent',
    contact: 'Contact',
    getStarted: 'Commencer',
    smartToilets: 'Toilettes Intelligentes',
    businessSolutions: 'Solutions Professionnelles',
    technology: 'Technologie',
    about: 'À Propos',
    viewAllProducts: 'Voir Tous les Produits',
    flagship: 'Produit Phare',
    productDescriptions: {
      rem7: 'Notre Toilette Intelligente Première',
      luxa: 'Ligne Luxe Ultime',
      luna: 'Compact Minimaliste',
      nova: 'Toilette Intelligente Familiale',
      aria: 'Design Éco-Luxe',
      vena: 'Bidet Premium',
      aurelius: 'Élégance Classique',
      aurelux: 'Édition Accent Doré',
      luma: 'Innovation Intelligente',
    },
  },
  
  // Common
  common: {
    learnMore: 'En Savoir Plus',
    viewDetails: 'Voir les Détails',
    requestQuote: 'Demander un Devis',
    downloadCatalog: 'Télécharger le Catalogue',
    contactUs: 'Nous Contacter',
    readMore: 'Lire la Suite',
    seeAll: 'Voir Tout',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    submit: 'Soumettre',
    send: 'Envoyer',
    close: 'Fermer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
  },
  
  // Homepage
  home: {
    heroTitle: 'Toilettes Intelligentes Premium pour les Marchés Européens',
    heroSubtitle: 'Découvrez le futur du luxe dans la salle de bain avec un design intelligent et une technologie de pointe',
    exploreCollection: 'Explorer la Collection',
    watchVideo: 'Regarder la Vidéo',
    featuredProducts: 'Produits Vedettes',
    whyChooseUs: 'Pourquoi Choisir Aureum VII Trading',
    testimonials: 'Ce Que Disent Nos Clients',
    certifications: 'Certifications et Normes',
  },
  
  // Products
  products: {
    title: 'Notre Collection de Toilettes Intelligentes',
    subtitle: 'Découvrez notre gamme de solutions de salle de bain intelligentes premium',
    features: 'Caractéristiques',
    specifications: 'Spécifications Techniques',
    installation: 'Guide d\'Installation',
    warranty: 'Informations sur la Garantie',
    dimensions: 'Dimensions',
    waterUsage: 'Consommation d\'Eau',
    powerConsumption: 'Consommation Électrique',
    weight: 'Poids',
    material: 'Matériau',
    certification: 'Certification',
    relatedProducts: 'Produits Connexes',
  },
  
  // Contact
  contact: {
    title: 'Contactez-Nous',
    subtitle: 'Nous serions ravis de vous entendre. Envoyez-nous un message et nous vous répondrons dès que possible.',
    name: 'Nom Complet',
    email: 'Adresse E-mail',
    phone: 'Numéro de Téléphone',
    company: 'Nom de l\'Entreprise',
    message: 'Votre Message',
    sendMessage: 'Envoyer le Message',
    ourLocation: 'Notre Emplacement',
    emailUs: 'Écrivez-Nous',
    callUs: 'Appelez-Nous',
    businessHours: 'Heures d\'Ouverture',
    weekdays: 'Lundi - Vendredi: 9h00 - 18h00',
    weekend: 'Samedi - Dimanche: Fermé',
  },
  
  // About
  about: {
    title: 'À Propos d\'Aureum VII Trading',
    subtitle: 'Votre partenaire de confiance pour les solutions de toilettes intelligentes premium en Europe',
    ourStory: 'Notre Histoire',
    ourMission: 'Notre Mission',
    ourVision: 'Notre Vision',
    ourValues: 'Nos Valeurs',
    quality: 'Qualité',
    innovation: 'Innovation',
    sustainability: 'Durabilité',
    customerFocus: 'Orientation Client',
  },
  
  // Footer
  footer: {
    description: 'Solutions de toilettes intelligentes premium pour le marché européen. Découvrez le luxe, l\'innovation et la durabilité.',
    quickLinks: 'Liens Rapides',
    products: 'Produits',
    support: 'Support',
    legal: 'Mentions Légales',
    privacyPolicy: 'Politique de Confidentialité',
    termsConditions: 'Conditions Générales',
    returnPolicy: 'Politique de Retour',
    shippingPolicy: 'Politique de Livraison',
    allRightsReserved: 'Tous droits réservés.',
    followUs: 'Suivez-Nous',
  },
  
  // Forms
  forms: {
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Veuillez entrer une adresse e-mail valide',
    invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
    messageSent: 'Votre message a été envoyé avec succès!',
    errorSending: 'Une erreur s\'est produite lors de l\'envoi de votre message. Veuillez réessayer.',
  },
  
  // FAQ
  faq: {
    title: 'Questions Fréquemment Posées',
    subtitle: 'Trouvez des réponses aux questions courantes sur nos toilettes intelligentes',
    stillHaveQuestions: 'Vous avez encore des questions?',
    contactSupport: 'Contactez notre équipe de support',
  },
  
  // Blog
  blog: {
    title: 'Derniers Articles',
    subtitle: 'Restez informé des dernières tendances en matière de technologie de salle de bain intelligente',
    readingTime: 'min de lecture',
    author: 'Par',
    publishedOn: 'Publié le',
    categories: 'Catégories',
    tags: 'Mots-clés',
    relatedArticles: 'Articles Connexes',
  },
  
  // Meta/SEO
  meta: {
    homeTitle: 'Toilettes Intelligentes | Aureum VII Trading',
    homeDescription: "Fournisseur B2B de toilettes intelligentes, baignoires en surface solide, spas et meubles-lavabos pour promoteurs, hôtels et architectes en Europe. Certifié CE.",
    productsTitle: 'Collection de Toilettes Intelligentes | Aureum VII',
    productsDescription: "Découvrez la gamme REM7 : chauffage instantané sans réservoir, sièges bidet chauffants et stérilisation UV. Certifié CE, disponible en volume pour vos projets.",
    contactTitle: 'Contact & Demandes Professionnelles | Aureum VII',
    contactDescription: "Contactez Aureum VII Trading à Marbella pour vos approvisionnements en toilettes intelligentes et équipements de salle de bain : tarifs pro, MOQ, OEM, livraison UE.",
    aboutTitle: 'À Propos d\'Aureum VII Trading | Fournisseur UE',
    aboutDescription: "Aureum VII Trading fournit depuis Marbella des toilettes intelligentes et équipements de salle de bain de luxe aux promoteurs, hôtels et architectes européens.",
    defaultTitle: 'Aureum VII Trading | Toilettes Intelligentes de Luxe',
    defaultDescription: "Toilettes intelligentes et équipements de salle de bain haut de gamme : sièges chauffants, fonctions bidet et commandes intelligentes. Livraison dans toute l'Europe.",
    rem7Title: 'REM7 — Toilette Intelligente Phare | Aureum VII',
    rem7Description: "REM7, la toilette intelligente phare d'Aureum VII Trading : bidet intégré, chauffage instantané, stérilisation UV et mode éco. Offre spéciale : 600 € par unité.",
    luxaTitle: 'LUXA — Toilette Intelligente de Luxe | Aureum VII',
    luxaDescription: "LUXA allie design européen et technologie avancée : bidet à température réglable, veilleuse LED et stérilisation UV. Offre spéciale : 600 € par unité.",
    bathSanitaryTitle: 'Baignoires & Sanitaires de Luxe | Aureum VII',
    bathSanitaryDescription: "Catalogue B2B de baignoires, spas balnéo, vasques et meubles de salle de bain premium. Tarifs volume pour hôtels, promoteurs et architectes en Europe.",
    businessTitle: 'Solutions B2B Hôtels & Promoteurs | Aureum VII',
    businessDescription: "Tarifs volume, accompagnement OEM et logistique européenne pour architectes, hôtels et promoteurs immobiliers. Demandez votre offre professionnelle.",
    compareTitle: 'Comparer les Toilettes Intelligentes | Aureum VII',
    compareDescription: "Comparez fonctions, prix et caractéristiques de tous les modèles REM7 côte à côte pour choisir la toilette intelligente adaptée à votre projet.",
    faqTitle: 'Questions Fréquentes | Aureum VII Trading',
    faqDescription: "Réponses sur l'installation, la garantie, l'entretien et les prix des toilettes intelligentes REM7. L'essentiel à savoir avant de commander.",
  },
  
  // Product Pages
  productPages: {
    luna: {
      title: 'LUNA M9 Toilette Intelligente de Luxe | Technologie Spa',
      description: 'Découvrez la toilette intelligente LUNA M9 avec chauffage instantané, écran numérique, nettoyage spa thérapeutique et fonctions bien-être.',
      heroTitle: 'LUNA',
      heroSubtitle: 'Modèle M9',
      heroDescription: 'La toilette intelligente de luxe LUNA M9 allie élégance intemporelle et fonctionnalité avancée axée sur le bien-être.',
      features: {
        heatedSeat: 'Siège chauffant avec veilleuse',
        washModes: 'Modes de lavage multiples',
        dryingFunction: 'Fonction de séchage intelligent',
        modernDesign: 'Design moderne et épuré',
      },
      cta: {
        downloadSpec: 'Télécharger les Spécifications',
        backToCollections: '← Retour aux Collections',
        requestQuote: 'Demander un Devis',
      },
    },
    luxa: {
      title: 'LUXA M80 Toilette Intelligente Premium | Système Bidet de Luxe',
      description: 'Toilette intelligente phare LUXA M80 avec capteurs de mouvement, chauffage sans réservoir, stérilisation UV et automatisation premium.',
      heroTitle: 'LUXA',
      heroSubtitle: 'Modèle: M80',
      heroDescription: 'Le LUXA M80 est le fleuron de notre collection premium, représentant le summum de l\'innovation en matière de salle de bains intelligente.',
      features: {
        motionSensor: 'Couvercle avec capteur de mouvement',
        tanklessHeating: 'Chauffage instantané sans réservoir',
        adjustableTemp: 'Température et pression d\'eau réglables',
        premiumCeramic: 'Céramique premium + couvercle à fermeture douce',
        ecoDesign: 'Design écologique',
      },
      cta: {
        downloadSpec: 'Télécharger les Spécifications',
        backToCollections: '← Retour aux Collections',
        requestQuote: 'Demander un Devis',
      },
    },
    aria: {
      title: 'ARIA H60 Toilette Intelligente Suspendue | Design Gain de Place',
      description: 'Toilette intelligente suspendue ARIA H60 avec design architectural élégant, technologie bidet avancée et installation gain de place.',
      heroTitle: 'ARIA',
      heroSubtitle: 'Modèle H60',
      heroDescription: 'L\'ARIA H60 met l\'accent sur le design architectural minimaliste avec un confort maximal et une fonctionnalité intelligente.',
      features: {
        bidetSpray: 'Jet bidet réglable',
        waterSaving: 'Technologie d\'économie d\'eau',
        compactFit: 'Ajustement compact pour petites salles de bains',
        softClose: 'Couvercle à fermeture douce',
      },
      cta: {
        downloadSpec: 'Télécharger les Spécifications',
        backToCollections: '← Retour aux Collections',
        requestQuote: 'Demander un Devis',
      },
    },
  },
};
